import type { Locale } from '../paraglide/runtime';

/** Each language named in itself, so a reader finds theirs without reading ours. */
export const ENDONYM: Record<Locale, string> = {
  en: 'English',
  'zh-Hans': '简体中文',
  'pt-BR': 'Português (Brasil)',
  es: 'Español',
  fr: 'Français',
  de: 'Deutsch',
  ru: 'Русский',
  it: 'Italiano',
};

/** The same names cut to fit the dashboard rail; ENDONYM stays the accessible name. */
export const SHORT_ENDONYM: Record<Locale, string> = {
  en: 'EN',
  'zh-Hans': '中文',
  'pt-BR': 'PT',
  es: 'ES',
  fr: 'FR',
  de: 'DE',
  ru: 'RU',
  it: 'IT',
};
